import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import {
    FETCH_USER_SUMMARY_AVERAGES,
    FETCH_USER_SUMMARY_AVERAGES_FETCHING,
    FETCH_USER_SUMMARY_AVERAGES_SUCCESS,
    FETCH_USER_SUMMARY_AVERAGES_FAIL
} from '../actions/userSummaryActions';

import { requestDailySummary, receiveDailySummary } from '../actions/index';
import {
    FETCH_USER_SUMMARY_MONTHLY,
    FETCH_USER_SUMMARY_MONTHLY_FETCHING,
    FETCH_USER_SUMMARY_MONTHLY_SUCCESS,
    FETCH_USER_SUMMARY_MONTHLY_FAIL,
    FETCH_DAILY_SUMMARY
} from 'actions/ActionTypes.js';

// Workers
export function* fetchUserSummaryAverages(action) {
    try {
        yield put({
            type: FETCH_USER_SUMMARY_AVERAGES_FETCHING
        });

        const { startDate, endDate } = action.payload;
        const response = yield call(gcApi.get, `/usersummary-service/stats/averages/${startDate}/${endDate}`);

        yield put({
            type: FETCH_USER_SUMMARY_AVERAGES_SUCCESS,
            userSummaryAverages: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_SUMMARY_AVERAGES_FAIL,
            userSummaryAverages: null
        });
    }
}

export function* fetchUserSummaryMonthly(action) {
    try {
        yield put({
            type: FETCH_USER_SUMMARY_MONTHLY_FETCHING
        });

        const { displayName, startDate, endDate } = action;
        const response = yield call(
            gcApi.get,
            `/usersummary-service/stats/monthly/${displayName}?startDate=${startDate}&endDate=${endDate}`
        );

        yield put({
            type: FETCH_USER_SUMMARY_MONTHLY_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_SUMMARY_MONTHLY_FAIL,
            data: null
        });
    }
}

export function* fetchDailySummary({ userId, date }) {
    try {
        yield put(requestDailySummary(userId, date));

        const response = yield gcApi.get(`/usersummary-service/validate/summary/${userId}/${date}`);

        yield put(receiveDailySummary(userId, response.data));
    } catch (e) {}
}

// Watchers
export const userSummarySagas = [
    takeEvery(FETCH_USER_SUMMARY_AVERAGES, fetchUserSummaryAverages),
    takeEvery(FETCH_USER_SUMMARY_MONTHLY, fetchUserSummaryMonthly),
    takeEvery(FETCH_DAILY_SUMMARY, fetchDailySummary)
];
